<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint='endPoint'
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="true"
            :enableView="false"
            :dataForm="dataForm"
            :detailUrl="detailUrl"
            :extra="extra"
             @answer="answer"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'
    export default {
        data() {
            return {
                extra: [
                    {
                    id: 1,
                    label: "",
                    class: "btn btn-crud view fas fa-signature",
                    title: "Responder",
                    name: "answer"
                    }
                ],
                crudName: 'Planos de Ação',
                newText: 'Cadastrar Plano de Ação',
                table: 'actionPlansTable',
                columns: ['id', 'research_id','dimension_id', 'responsible_id', 'name', 'priority_id', 'answer', 'actions'],
                tableData: ['id', 'research_id','dimension_id', 'responsible_id', 'name', 'priority_id', 'answer'],
                options: {
                    filterByColumn: true,
                    debounce: 1000,
                    sortable: ['id', 'research_id','dimension_id', 'responsible_id', 'name', 'priority_id'],
                    filterable: ['id', 'research_id','dimension_id','responsible_id', 'name', 'priority_id'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': '#',
                        'research_id': 'Pesquisa',
                        'responsible_id': 'Responsável',
                        'name': 'Nome',
                        'priority_id': 'Prioridade',
                        'answer': 'Respondido',
                        'dimension_id': 'Dimensão',
                        'actions' : 'Ações'
                    },
                    templates: {
                        research_id(h, row){
                            return row.research.name
                        },
                        priority_id(h, row){
                            return row.priority.name
                        },
                        responsible_id(h, row){
                            return row.responsible.name
                        },
                        answer(h, row){
                            return row.answer ? <i class="fas fa-check green"></i> : <i class="fas fa-times red"></i>
                        },
                        dimension_id(h, row){
                            if(row.dimension){
                                return row.dimension.name
                            }else
                            return "Não registrado"
                        }
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [
                            'priority', 'responsible', 'research', 'answer', 'dimension'
                        ];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    }
                },
                endPoint: 'actionplans/',
                detailUrl: '/actionPlan',
                dataForm: {}
            }
        },
        methods: {
            answer(data) {
            this.$router.push({ path: "/action/actionPlan/" + data.row.id });
            },
            query: function (query) {
                let columns = {
                    id: 'id',
                    research_id: 'research[name]',
                    responsible_id: 'responsible[name]',
                    dimension_id: 'dimension[name]',
                    name: 'name',
                    priority_id: 'priority[name]',
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                if(this.$route.query.research_id){
                    filters += 'research_id=' + this.$route.query.research_id + '&';
                }

                return filters;
            },
        },
        mounted(){
          const self = this;
        },
        components: {
            BaseCrud
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ActionPlan/Crud.vue